import { useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
// import { isMobile } from 'react-device-detect';
import { isEmpty } from 'lodash'
import { getOrderDetail, createPayment, userCancelOrder } from 'routes/orderService'

import OrderSummary from "./OrderSummary/OrderSummary";
import "./Order.css";
import { invoiceTypes, payMethods } from "helpers/const";

const Order = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [step, setStep] = useState(0)
  const [invoiceInfo, setInvoiceInfo] = useState({ carrierType: invoiceTypes.carrier, carrierCode: localStorage?.carrierCode || '' });
  const [payMethod, setPayMethod] = useState({type: null});
  const [orderInfo, setOrderInfo] = useState({});

  const initOrder = async () => {
    try {
      const res = await getOrderDetail({ id });
      if (res.status === 'done') {
        navigate('/orderConfirm');
      } else if (res.status.indexOf('cancel') !== -1 ) {
        navigate('/orderCancel');
      } else if (res.status == 'expired' ) {
        navigate('/orderFailed');
      }else {
        setOrderInfo(res);
      }
    } catch (error) {
      console.error('[OrderSummary]: ', error)
      navigate('/orderNotFound');
    }
  }

  const orderCancel = async () => {
    try {
      await userCancelOrder({ uuid: orderInfo.uuid });
      navigate('/orderCancel');
    } catch (error) {
      console.error('[orderCancel]: ', error)
    }
  }

  const checkOut = async () => {
    try {
      if (invoiceInfo.carrierType === invoiceTypes.carrier) {
        localStorage.carrierCode = invoiceInfo.carrierCode
      }

      setStep(step + 1);
      const payload = {
        ...invoiceInfo,
        id,
        payMethod
      }
      const res = await createPayment(payload);
      if (payMethod.type === payMethods.linePay) {
         window.location.replace(res.info.paymentUrl.web);
      } else {
        if (res?.Status === 'S'){
          if (payMethod.type === payMethods.creditCard) {
            window.location.replace(res.CardParam.CardPayURL);
          } else if (payMethod.type === payMethods.mobilePay) {
            window.location.replace(res.MobileParam.MobilePayURL);
          } else { //payMethods.alipay
            // not ready
          }
        }
      }
    } catch (error) {
      console.debug('checkOut res: ', error);
      navigate('/orderCreateFail');
    }
  };

  useEffect(() => {
    if (isEmpty(id)) return;
    initOrder();
  }, [id])

  return (
    <>
      <div className="main-order-container">
        <div className="order-summary">
          <h2 className='summary-title'>
            訂單明細 / Order detail
          </h2>
          {step === 0 &&
            <OrderSummary {...{
              invoiceInfo, setInvoiceInfo, orderInfo, orderCancel, checkOut, payMethod, setPayMethod
            }} />
          }
          {step !== 0 &&
            <div style={{ height: "75vh" }} className="sub-container">
              <h3 className='summary-title'>
                付款中... / Processing...
              </h3>
            </div>
          }
        </div>
      </div>
    </>
  );
};
export default Order;
